import content from "app-content";
import Select from "../Select";
import PropTypes from "prop-types";
import styles from "./index.css";
import { sortConfig } from "../../../../savedItemsSortConfig";

const SortSelect = ({ value, setValue, focus, onBlur }) => (
  <div className={styles.sortSelect}>
    <div>
      <Select
        id="sortBy"
        className={styles.select}
        label={content.saved_items_sort_by}
        options={sortConfig.map(({ text, value }) => ({ text, value }))}
        value={value}
        onChange={setValue}
        focus={focus}
        onBlur={onBlur}
      />
    </div>
    <label htmlFor="sortBy" className={styles.label} aria-hidden={true}>
      {content.saved_items_controls_sort_label}
    </label>
  </div>
);

SortSelect.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  focus: PropTypes.bool.isRequired,
  onBlur: PropTypes.func.isRequired
};

export default SortSelect;
